import { render } from "./ListeFaqTagPage.vue?vue&type=template&id=4a1eb504&ts=true"
import script from "./ListeFaqTagPage.vue?vue&type=script&lang=ts"
export * from "./ListeFaqTagPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__